export default "__VITE_ASSET__76c178ca__"